import { axios } from '../../../lib/axios';

export const dislikePost = async (key: string) => {
  return await axios.post(`posts/${key}/dislike`);
};
